import React, { Fragment} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Comunes/Home";
import Navbar from "./Comunes/Navbar";
import LoginForm from "./Comunes/LoginForm";
import Pie from "./Comunes/Pie";
import ProtectedRoute from "./Comunes/ProtectedRoute";
import { AuthProvider } from "./contextos/AuthProvider";
import { UserProvider } from "./contextos/UserProvider";
import { DocProvider } from "./contextos/DocProvider"
import GeneralCliente from "./Clientes/GeneralCliente";


import GeneralCia from "./Companias/GeneralCia";
import DetalleCia from "./Companias/DetalleCia";
import FichaCliente from "./Clientes/FichaCliente";
import GeneralCatalogo from "./Catalogo/GeneralCatalogo";
import FichaCatalogo from "./Catalogo/FichaCatalogo";
import BaseDoc from "./CreaDocumento/BaseDoc";
import Facturas from "./Documentos/Facturas";
import Tiquetes from "./Documentos/Tiquetes";
import NCs from "./Documentos/NCs";
import Compras from "./Documentos/Compras";
import SubirCompras from "./Documentos/SubirCompras";
import Cotizaciones from "./Documentos/Cotizaciones";
import FECs from "./Documentos/FECs";
import BasePagos from "./Pagos/BasePagos";
import REPs from "./Documentos/REPs";
import Reportes from "./Reporteria/Reportes";
import Exportacion from "./Documentos/Exportacion";
import NDs from "./Documentos/NDs";
import MisDatos from "./Reporteria/MisDatos";
import Tutoriales from "./Reporteria/Tutoriales";

function App() {
  const [EntidadActual, setEntidadActual] = React.useState(0);
  const CambiaCia = (idCia) => {
    setEntidadActual(idCia);
  }


  return (
    <Fragment>
      <AuthProvider>
        <UserProvider >
          <DocProvider>
            <Router>
            <Navbar />
              <Routes>
                <Route path="/login" element={<LoginForm />} />
                <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="/Companias/GeneralCia" element={<ProtectedRoute><GeneralCia CambiaCia={CambiaCia} /></ProtectedRoute>} />
                <Route path="/Companias/Detalle" element={<ProtectedRoute><DetalleCia EntidadActual={EntidadActual} /></ProtectedRoute>} />
                <Route path="/Clientes/GeneralCliente" element={<ProtectedRoute><GeneralCliente CambiaCia={CambiaCia} /></ProtectedRoute>} /> 
                <Route path="/Clientes/FichaCliente" element={<ProtectedRoute><FichaCliente EntidadActual={EntidadActual}  CambiaCia={CambiaCia}  /></ProtectedRoute>} /> 
                <Route path="/Productos/CatalogoGeneral" element={<ProtectedRoute><GeneralCatalogo EntidadActual={EntidadActual}  CambiaCia={CambiaCia}  /></ProtectedRoute>} /> 
                <Route path="/Productos/FichaCatalogo" element={<ProtectedRoute><FichaCatalogo EntidadActual={EntidadActual}  CambiaCia={CambiaCia}  /></ProtectedRoute>} />
                <Route path="/Documentos/CrearDocumento" element={<ProtectedRoute><BaseDoc  /></ProtectedRoute>} />
                <Route path="/Documentos/Facturas" element={<ProtectedRoute> <Facturas  /> </ProtectedRoute>} />
                <Route path="/Documentos/Tiquetes" element={<ProtectedRoute> <Tiquetes  /> </ProtectedRoute>} />
                <Route path="/Documentos/Cotizaciones" element={<ProtectedRoute> <Cotizaciones /> </ProtectedRoute>} />
                <Route path="/Documentos/NCs" element={<ProtectedRoute> <NCs  /> </ProtectedRoute>} />
                <Route path="/Documentos/NDs" element={<ProtectedRoute> <NDs  /> </ProtectedRoute>} />
                <Route path="/Documentos/Exportacion" element={<ProtectedRoute> <Exportacion  /> </ProtectedRoute>} />
                <Route path="/Documentos/Compras" element={<ProtectedRoute> <Compras /> </ProtectedRoute>} />
                <Route path="/Documentos/SubirCompras" element={<ProtectedRoute> <SubirCompras /> </ProtectedRoute>} />
                <Route path="/Documentos/FECs" element={<ProtectedRoute> <FECs /> </ProtectedRoute>} />
                <Route path="/Documentos/RecibosPago" element={<ProtectedRoute><REPs  /></ProtectedRoute>} />
                <Route path="/Pagos" element={<ProtectedRoute><BasePagos  /></ProtectedRoute>} />
                <Route path="/Reporteria/Reportes" element={<ProtectedRoute><Reportes  /></ProtectedRoute>} />
                <Route path="/MisDatos" element={<ProtectedRoute><MisDatos  /></ProtectedRoute>} />
                <Route path="/Reporteria/Tutoriales" element={<ProtectedRoute> <Tutoriales /> </ProtectedRoute>} />
              </Routes>
              <Pie />
            </Router>
          </DocProvider>
        </UserProvider>
      </AuthProvider>
    </Fragment>
  );
}

export default App;
